import { InsightData } from 'schemas/action/InsightDataSchema'
import { Filter } from 'schemas/FilterSchema'
import { SearchFilterComposingStrategy } from './searchFilterComposingStrategy'

const composeDetailSearchFilter = (filter: Filter, insights: InsightData[]) => ({
  ...filter,
  things: [
    ...(filter.things || []),
    ...Array.from(insights).flatMap((insight) => [insight.name, ...(insight.variants || [])])
  ]
})

const generateThingsInsightStrategy = (): SearchFilterComposingStrategy => ({
  composeDetailSearchFilter
})

export default generateThingsInsightStrategy
